"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IBPayCardDeliverySchema", {
  enumerable: true,
  get: function get() {
    return _ibPayCardDelivery.IBPayCardDeliverySchema;
  }
});
Object.defineProperty(exports, "IBPayCardLimitsSchema", {
  enumerable: true,
  get: function get() {
    return _ibPayCardLimits.IBPayCardLimitsSchema;
  }
});
Object.defineProperty(exports, "IBPayCardUserSchema", {
  enumerable: true,
  get: function get() {
    return _ibPayCardUser.IBPayCardUserSchema;
  }
});
Object.defineProperty(exports, "addressSchema", {
  enumerable: true,
  get: function get() {
    return _address.addressSchema;
  }
});
Object.defineProperty(exports, "cardLabelSchema", {
  enumerable: true,
  get: function get() {
    return _cardLabel.cardLabelSchema;
  }
});
Object.defineProperty(exports, "cardTypeSchema", {
  enumerable: true,
  get: function get() {
    return _cardType.cardTypeSchema;
  }
});
Object.defineProperty(exports, "companyNameOfEmployeeSchema", {
  enumerable: true,
  get: function get() {
    return _companyNameOfEmployee.companyNameOfEmployeeSchema;
  }
});
Object.defineProperty(exports, "companyNameSchema", {
  enumerable: true,
  get: function get() {
    return _companyName.companyNameSchema;
  }
});
Object.defineProperty(exports, "companyRegistrationNumberSchema", {
  enumerable: true,
  get: function get() {
    return _companyRegistrationNumber.companyRegistrationNumberSchema;
  }
});
Object.defineProperty(exports, "dateOfBirthSchema", {
  enumerable: true,
  get: function get() {
    return _dateOfBirth.dateOfBirthSchema;
  }
});
Object.defineProperty(exports, "defaultQuestionsAndSchema", {
  enumerable: true,
  get: function get() {
    return _registrationQuestions.defaultQuestionsAndSchema;
  }
});
Object.defineProperty(exports, "estimatedAccountSpendingSchema", {
  enumerable: true,
  get: function get() {
    return _estimatedAccountSpending.estimatedAccountSpendingSchema;
  }
});
Object.defineProperty(exports, "hotelPolicySchema", {
  enumerable: true,
  get: function get() {
    return _hotelPolicy.hotelPolicySchema;
  }
});
Object.defineProperty(exports, "parentCompanySchema", {
  enumerable: true,
  get: function get() {
    return _parentCompany.parentCompanySchema;
  }
});
Object.defineProperty(exports, "partnerDetailsSchema", {
  enumerable: true,
  get: function get() {
    return _partnerDetails.partnerDetailsSchema;
  }
});
Object.defineProperty(exports, "registeredCharityNumberSchema", {
  enumerable: true,
  get: function get() {
    return _registeredCharityNumber.registeredCharityNumberSchema;
  }
});
Object.defineProperty(exports, "timeTradingSchema", {
  enumerable: true,
  get: function get() {
    return _timeTrading.timeTradingSchema;
  }
});
var _companyName = require("./company-name.schema");
var _cardType = require("./card-type.schema");
var _cardLabel = require("./card-label.schema");
var _address = require("./address.schema");
var _ibPayCardLimits = require("./ib-pay-card-limits.schema");
var _ibPayCardUser = require("./ib-pay-card-user.schema");
var _ibPayCardDelivery = require("./ib-pay-card-delivery.schema");
var _companyNameOfEmployee = require("./company-name-of-employee.schema");
var _companyRegistrationNumber = require("./company-registration-number.schema");
var _dateOfBirth = require("./date-of-birth.schema");
var _registeredCharityNumber = require("./registered-charity-number.schema");
var _timeTrading = require("./time-trading.schema");
var _parentCompany = require("./parent-company.schema");
var _partnerDetails = require("./partner-details.schema");
var _hotelPolicy = require("./hotel-policy.schema");
var _estimatedAccountSpending = require("./estimated-account-spending.schema");
var _registrationQuestions = require("./registration-questions.schema");